// extracted by mini-css-extract-plugin
export default {"separator":"decision_separator-module__separator--2b2xA"};